import * as Notification from './Notification'

export default Notification
